import { SET_IS_OPEN_EMAILS_MODAL } from '../actionTypes';
import { actions } from '../reducer';

import resetAuthEmailsForm from './resetAuthEmailsForm';

export default (value) => (dispatch) => {
    dispatch(actions[SET_IS_OPEN_EMAILS_MODAL](value));
    if (!value) dispatch(resetAuthEmailsForm());
};
